function syncAmpmBundleCardState(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    root.find('.js-ampm-bundle-card').each(function () {
        var card = jQuery(this);
        var isActive = card.find('.js-ampm-bundle-heading').hasClass('active');
        card.toggleClass('is-active', isActive);
    });
}

function getSelectedPurchaseTab(wrapper, fallbackRoot) {
    var selectedTab = '';

    if (wrapper && wrapper.length) {
        selectedTab = wrapper.attr('data-selected-purchase-tab') || '';
    }

    if (!selectedTab) {
        var searchRoot = fallbackRoot && fallbackRoot.length ? fallbackRoot : wrapper;
        var activeHeading = searchRoot && searchRoot.length
            ? searchRoot.find('.custom_widget_subscription_heading_item.active').first()
            : jQuery();

        if (activeHeading.length) {
            selectedTab = activeHeading.attr('data_tab') || '';
        }
    }

    return selectedTab || '1';
}

function syncSubscriptionContentState(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    root.find('.custom_widget_subscription').each(function () {
        var subscriptionCard = jQuery(this);
        var subscriptionDetails = subscriptionCard.find('.custom_widget_subscription_content[data_tab="1"]');
        var oneTimeContent = subscriptionCard.find('.custom_widget_subscription_content[data_tab="2"]');
        var wrapper = subscriptionCard.closest('.custom_boc_subscripe_full');
        var keepSubscribeOpenOnOneTimeClick = wrapper.attr('data-keep-subscribe-open-on-one-time-click') === 'true';
        var currentTab = getSelectedPurchaseTab(wrapper, subscriptionCard);
        if (wrapper.length) {
            wrapper.toggleClass('is-subscribe-tab-active', currentTab === "1" || (keepSubscribeOpenOnOneTimeClick && currentTab === "2"));
            wrapper.toggleClass('is-one-time-selected', currentTab === "2");
            wrapper.find('.custom_widget_subscription .custom_widget_subscription_heading_item[data_tab="1"]').toggleClass('is-open', currentTab === "1" || (keepSubscribeOpenOnOneTimeClick && currentTab === "2"));
            wrapper.find('.custom_widget_subscription .custom_widget_subscription_heading_item[data_tab="1"]').toggleClass('is-selected', currentTab === "1");
            wrapper.find('.js-one-time-card').toggleClass('is-selected', currentTab === "2");
            wrapper.find('.js-one-time-card .custom_widget_subscription_heading_item').toggleClass('is-selected', currentTab === "2");
        }

        if (currentTab === "1") {
            subscriptionDetails.show();
            if (oneTimeContent.length) oneTimeContent.hide();
        } else if (currentTab === "2") {
            if (keepSubscribeOpenOnOneTimeClick) {
                subscriptionDetails.show();
            } else {
                subscriptionDetails.hide();
            }
            if (oneTimeContent.length) oneTimeContent.show();
        } else {
            subscriptionDetails.hide();
            if (oneTimeContent.length) oneTimeContent.hide();
        }
    });
}

function syncBetweenOptionsTextState(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    root.find('.custom_boc_subscripe_full').each(function () {
        var wrapper = jQuery(this);
        var betweenText = wrapper.find('.custom_widget_subscription_between_text');
        if (!betweenText.length) return;

        var showOnlyOneTime = betweenText.attr('data-show-one-time-only') === 'true';
        if (!showOnlyOneTime) {
            betweenText.show();
            return;
        }

        var hasSubscribeOption = wrapper.find('.custom_widget_subscription_heading_item[data_tab="1"]').length > 0;
        var selectedTab = getSelectedPurchaseTab(wrapper, wrapper);
        var shouldShow = false;

        if (selectedTab) {
            shouldShow = selectedTab === '2';
        } else if (!hasSubscribeOption) {
            // One-time only products should keep helper text visible.
            shouldShow = true;
        }

        betweenText.toggle(shouldShow);
    });
}

function getAtcSubFrequencyValue(wrapper, tab) {
    if (!wrapper || !wrapper.length) {
        return 1;
    }

    var tabKey = String(tab || '1');
    var tabItem = wrapper
        .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item[data_tab="' + tabKey + '"]')
        .first();

    if (tabItem.length) {
        var tabText = tabItem.text().trim();
        var match = tabText.match(/(\d+)/);
        if (match && match[1]) {
            var parsed = parseInt(match[1], 10);
            if (!isNaN(parsed) && parsed > 0) {
                return parsed;
            }
        }
    }

    if (tabKey === '2') {
        return 3;
    }
    if (tabKey === '3') {
        return 6;
    }
    return 1;
}

function getAmpmBundleFrequencyValue(wrapper, fallbackTab) {
    if (!wrapper || !wrapper.length) {
        return 1;
    }

    var select = wrapper.find('.js-ampm-bundle-interval').first();
    if (select.length && select[0] && select[0].options && select[0].options.length) {
        var selectedIndex = select[0].selectedIndex >= 0 ? select[0].selectedIndex : 0;
        var optionNode = select[0].options[selectedIndex] || null;
        if (optionNode) {
            var optionTab = jQuery(optionNode).attr('data-tab');
            if (optionTab) {
                return getAtcSubFrequencyValue(wrapper, optionTab);
            }
        }
    }

    return getAtcSubFrequencyValue(wrapper, fallbackTab || '1');
}

function renderAtcSubPackFrequencyCopy(template, packs, frequency) {
    if (template === undefined || template === null) {
        return '';
    }

    var source = String(template);
    if (!source) {
        return '';
    }

    if (/\{packs\}|\{frequency\}|\{month\}|\{month_display\}|\{packs_display\}|\{pack_display\}|\{bundle\}|\{bundle_display\}|\{box\}|\{box_display\}|\{box display\}/i.test(source)) {
        var packsCount = Number(packs) || 1;
        var frequencyCount = Number(frequency) || 1;
        var monthDisplay = frequencyCount === 1 ? 'Month' : String(frequencyCount) + ' Months';
        var packsDisplay = String(packsCount) + ' Pack' + (packsCount === 1 ? '' : 's');
        var bundleDisplay = String(frequencyCount) + ' Bundle' + (frequencyCount === 1 ? '' : 's');
        var boxDisplay = String(frequencyCount) + ' Box' + (frequencyCount === 1 ? '' : 'es');
        return source
            .replace(/\{packs\}/gi, String(packsCount))
            .replace(/\{frequency\}/gi, String(frequencyCount))
            .replace(/\{month\}/gi, String(frequencyCount))
            .replace(/\{month_display\}/gi, monthDisplay)
            .replace(/\{packs_display\}/gi, packsDisplay)
            .replace(/\{pack_display\}/gi, packsDisplay)
            .replace(/\{bundle\}/gi, String(frequencyCount))
            .replace(/\{bundle_display\}/gi, bundleDisplay)
            .replace(/\{box\}/gi, String(frequencyCount))
            .replace(/\{box_display\}/gi, boxDisplay)
            .replace(/\{box display\}/gi, boxDisplay);
    }

    var compact = source.replace(/\s+/g, ' ').trim();
    if (/^\d+\s+pack(?:s)?\s+every\s+(?:\d+\s+)?month(?:s)?$/i.test(compact)) {
        var fallbackPacks = Number(packs) || 1;
        var fallbackFrequency = Number(frequency) || 1;
        var fallbackMonthDisplay = fallbackFrequency === 1 ? 'Month' : String(fallbackFrequency) + ' Months';
        return (
            String(fallbackPacks) +
            ' Pack' +
            (fallbackPacks === 1 ? '' : 's') +
            ' Every ' +
            fallbackMonthDisplay
        );
    }

    return source;
}

function applyAtcSubPackFrequencyCopy(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    var wrappers = root.hasClass('custom_boc_subscripe_full') ? root : root.find('.custom_boc_subscripe_full');

    wrappers.each(function () {
        var wrapper = jQuery(this);
        wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member_content[data_tab]').each(function () {
            var content = jQuery(this);
            var tab = content.attr('data_tab') || '1';
            var frequency = getAtcSubFrequencyValue(wrapper, tab);
            var packs = frequency;

            content.find('.js-atc-pack-frequency-copy').each(function () {
                var node = jQuery(this);
                var template = node.attr('data-pack-frequency-template');
                if (typeof template !== 'string' || !template.length) {
                    template = node.text().trim();
                    node.attr('data-pack-frequency-template', template);
                }

                var resolved = renderAtcSubPackFrequencyCopy(template, packs, frequency);
                if (node.text() !== resolved) {
                    node.text(resolved);
                }
            });
        });

        var activeDurationTab = getAtcSubV2ActiveDurationTab(wrapper);
        var ampmFrequency = getAmpmBundleFrequencyValue(wrapper, activeDurationTab);
        var ampmPacks = ampmFrequency;
        wrapper.find('.custom_widget_subscription_content[data_tab="1"] .js-v2-ampm-benefits .js-atc-pack-frequency-copy, .custom_widget_subscription_bundle .subscription_heading_member_content--ampm-bundle .js-atc-pack-frequency-copy').each(function () {
            var node = jQuery(this);
            var template = node.attr('data-pack-frequency-template');
            if (typeof template !== 'string' || !template.length) {
                template = node.text().trim();
                node.attr('data-pack-frequency-template', template);
            }

            var resolved = renderAtcSubPackFrequencyCopy(template, ampmPacks, ampmFrequency);
            if (node.text() !== resolved) {
                node.text(resolved);
            }
        });
    });
}

function getStickyAtcV2Target(wrapper) {
    if (!wrapper || !wrapper.length) {
        return jQuery();
    }

    var sectionRoot = wrapper.closest('.section[id]');
    if (!sectionRoot.length) {
        return jQuery();
    }

    return jQuery('#productStickyInfo-' + sectionRoot.attr('id') + '.product__sticky-info--compact-v2');
}

function getStickyAtcV2Fallback(sticky, key) {
    if (!sticky || !sticky.length) {
        return '';
    }

    var card = sticky.find('.js-sticky-atc-v2-card').first();
    if (!card.length) {
        return '';
    }

    var value = card.attr('data-' + key);
    return typeof value === 'string' ? jQuery.trim(value) : '';
}

function syncStickyAtcV2Card(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    var wrappers = root.hasClass('custom_boc_subscripe_full') ? root : root.find('.custom_boc_subscripe_full');

    wrappers.each(function () {
        var wrapper = jQuery(this);
        var sticky = getStickyAtcV2Target(wrapper);
        if (!sticky.length) {
            return;
        }

        var activeChoice = wrapper.find('.js-v2-bundle-choice.is-active').first();
        var choice = activeChoice.attr('data-choice') || (wrapper.hasClass('is-v2-ampm-active') ? 'ampm' : 'rise');
        var activeHeadingTab = getSelectedPurchaseTab(wrapper, wrapper);
        var activeDuration = wrapper
            .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item.active[data_tab]')
            .first();
        var durationText = activeDuration.length ? jQuery.trim(activeDuration.text()) : '';
        var title = activeChoice.find('.atc-sub-v2__bundle-title').first().text();
        var subtitle = '';

        title = jQuery.trim(title);
        if (!title) {
            title = choice === 'ampm'
                ? getStickyAtcV2Fallback(sticky, 'ampm-title')
                : getStickyAtcV2Fallback(sticky, 'rise-title');
        }

        if (activeHeadingTab === '1' || activeHeadingTab === '3') {
            subtitle = 'Subscribe';
            if (durationText) {
                subtitle += ' | ' + durationText;
            }
        } else if (activeHeadingTab === '2') {
            subtitle = 'One-time purchase';
        }

        if (!subtitle) {
            subtitle = choice === 'ampm'
                ? getStickyAtcV2Fallback(sticky, 'ampm-subtitle')
                : getStickyAtcV2Fallback(sticky, 'rise-subtitle');
        }

        var titleNode = sticky.find('.js-sticky-atc-v2-title').first();
        var subtitleNode = sticky.find('.js-sticky-atc-v2-subtitle').first();
        if (titleNode.length) {
            titleNode.text(title || getStickyAtcV2Fallback(sticky, 'default-title'));
        }
        if (subtitleNode.length) {
            subtitleNode.text(subtitle || getStickyAtcV2Fallback(sticky, 'default-subtitle'));
        }

        var singleImage = sticky.find('.js-sticky-atc-v2-image-single').first();
        var pairImages = sticky.find('.js-sticky-atc-v2-image-pair').first();
        if (choice === 'ampm') {
            var sourceImages = activeChoice.find('.atc-sub-v2__bundle-image-item');
            var leftSrc = sourceImages.eq(0).attr('src');
            var rightSrc = sourceImages.eq(1).attr('src');
            var leftImage = sticky.find('.js-sticky-atc-v2-image-left').first();
            var rightImage = sticky.find('.js-sticky-atc-v2-image-right').first();

            if (leftImage.length && leftSrc) {
                leftImage.attr('src', leftSrc);
                leftImage.attr('alt', title || getStickyAtcV2Fallback(sticky, 'ampm-title'));
            }
            if (rightImage.length && rightSrc) {
                rightImage.attr('src', rightSrc);
                rightImage.attr('alt', title || getStickyAtcV2Fallback(sticky, 'ampm-title'));
            }

            if (singleImage.length) {
                singleImage.attr('hidden', 'hidden');
            }
            if (pairImages.length) {
                pairImages.removeAttr('hidden');
            }
        } else {
            var riseSrc = activeChoice.find('.atc-sub-v2__bundle-image-item').first().attr('src');
            if (singleImage.length) {
                if (riseSrc) {
                    singleImage.attr('src', riseSrc);
                }
                singleImage.attr('alt', title || getStickyAtcV2Fallback(sticky, 'rise-title'));
                singleImage.removeAttr('hidden');
            }
            if (pairImages.length) {
                pairImages.attr('hidden', 'hidden');
            }
        }
    });
}

function extractAtcSubV2DiscountPercent(text) {
    if (!text) {
        return '';
    }
    var match = String(text).match(/(\d+(?:[.,]\d+)?)\s*%/);
    if (!match || !match[1]) {
        return '';
    }
    return match[1].replace(',', '.') + '%';
}

function normalizeDiscountPercent(value) {
    if (value === undefined || value === null) {
        return '';
    }
    var text = String(value).trim();
    if (!text) {
        return '';
    }
    var match = text.match(/(-?\d+(?:[.,]\d+)?)/);
    if (!match || !match[1]) {
        return '';
    }
    return match[1].replace(',', '.') + '%';
}

function templateHasDiscountToken(template) {
    return typeof template === 'string' && /\{discount\}/i.test(template);
}

function applyDiscountTemplateValue(template, discountPercent) {
    if (typeof template !== 'string') {
        return '';
    }
    return template.replace(/\{discount\}/gi, discountPercent || '');
}

function applyDiscountTemplates(wrapper, discountPercent, context) {
    if (!wrapper || !wrapper.length) {
        return;
    }
    context = context || {};
    var selectedPurchaseTab = getSelectedPurchaseTab(wrapper, wrapper);
    wrapper.find('[data-discount-template], [data-discount-template-html]').each(function () {
        var node = jQuery(this);
        var discountForNode = discountPercent;
        var source = (node.attr('data-discount-source') || '').toLowerCase();
        var forceTemplateValue = false;
        var htmlTemplateOverride = '';
        var textTemplateOverride = '';
        if (source === 'ampm') {
            if (selectedPurchaseTab === '2') {
                htmlTemplateOverride = node.attr('data-one-time-template-html') || '';
                textTemplateOverride = node.attr('data-one-time-template') || '';
                forceTemplateValue = !!(htmlTemplateOverride || textTemplateOverride);
            }
            if (context.ampmDiscount) {
                discountForNode = context.ampmDiscount;
            } else if (context.activeDiscount) {
                discountForNode = context.activeDiscount;
            } else {
                return;
            }
            node.removeAttr('data-discount-ampm-frozen');
        } else if (source === 'active' && context.activeDiscount) {
            discountForNode = context.activeDiscount;
        }

        var htmlTemplate = htmlTemplateOverride || node.attr('data-discount-template-html');
        if (typeof htmlTemplate === 'string' && htmlTemplate.length) {
            if (!forceTemplateValue && !templateHasDiscountToken(htmlTemplate)) {
                return;
            }
            node.html(applyDiscountTemplateValue(htmlTemplate, discountForNode));
            return;
        }
        var textTemplate = textTemplateOverride || node.attr('data-discount-template');
        if (typeof textTemplate !== 'string' || (!forceTemplateValue && !templateHasDiscountToken(textTemplate))) {
            return;
        }
        node.text(applyDiscountTemplateValue(textTemplate, discountForNode));
    });
}

function getAmpmBundleDiscount(wrapper) {
    if (!wrapper || !wrapper.length) {
        return '';
    }
    var selectedPurchaseTab = getSelectedPurchaseTab(wrapper, wrapper);
    var activeTab = wrapper
        .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item.active[data_tab]')
        .first()
        .attr('data_tab');
    var select = wrapper.find('.js-ampm-bundle-interval').first();
    if (!select.length || !select[0].options || !select[0].options.length) {
        return '';
    }

    var optionNode = null;
    if (activeTab) {
        optionNode = select.find('option[data-tab="' + activeTab + '"]').get(0) || null;
    }

    if (!optionNode) {
        var selectedIndex = select[0].selectedIndex >= 0 ? select[0].selectedIndex : 0;
        optionNode = select[0].options[selectedIndex] || select[0].options[0] || null;
    }
    if (!optionNode) return '';

    if (selectedPurchaseTab === '2') {
        return normalizeDiscountPercent(jQuery(optionNode).attr('data-total-one-time-discount-pct'));
    }

    return normalizeDiscountPercent(jQuery(optionNode).attr('data-total-discount-pct'));
}

function getAtcSubV2ActiveDiscount(wrapper) {
    if (!wrapper || !wrapper.length) {
        return '';
    }

    var discountPercent = '';
    if (wrapper.hasClass('is-v2-ampm-active')) {
        discountPercent = getAmpmBundleDiscount(wrapper);
    }

    if (!discountPercent) {
        var activeSaveText = wrapper
            .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member')
            .not('.months')
            .first()
            .find('.subscription_heading_member_item.active span')
            .first()
            .text()
            .trim();
        discountPercent = extractAtcSubV2DiscountPercent(activeSaveText);
    }

    return discountPercent;
}

function updateAtcSubV2SubscribeLabel(wrapper) {
    if (!wrapper || !wrapper.length || !wrapper.hasClass('js-atc-sub-v2')) {
        return;
    }

    var subscribeLabel = wrapper.find('.js-v2-subscribe-label').first();
    var discountPercent = getAtcSubV2ActiveDiscount(wrapper);
    var ampmDiscount = getAmpmBundleDiscount(wrapper);
    var inlineSaveEnabled = false;

    if (subscribeLabel.length) {
        inlineSaveEnabled = subscribeLabel.attr('data-inline-save') === 'true';
        var baseLabel = subscribeLabel.attr('data-base-label') || subscribeLabel.text().trim();
        if (!subscribeLabel.attr('data-base-label')) {
            subscribeLabel.attr('data-base-label', baseLabel);
        }

        var nextLabel = baseLabel;
        if (templateHasDiscountToken(baseLabel)) {
            nextLabel = applyDiscountTemplateValue(baseLabel, discountPercent);
        } else if (inlineSaveEnabled && discountPercent) {
            nextLabel = (baseLabel + ' ' + discountPercent).trim();
        }

        subscribeLabel.text(nextLabel);
    }

    wrapper.toggleClass('is-v2-inline-save-enabled', inlineSaveEnabled);
    wrapper.find('.price_subscription_trigger.subscription_prices_main .product_compareprice_custom_save').toggle(!inlineSaveEnabled);
    applyDiscountTemplates(wrapper, discountPercent, {
        activeDiscount: discountPercent,
        ampmDiscount: ampmDiscount
    });
}

function syncAtcSubV4State(wrapper) {
    if (!wrapper || !wrapper.length || !wrapper.hasClass('js-atc-sub-v4')) {
        return;
    }

    var select = wrapper.find('.js-ampm-bundle-interval').first();
    if (!select.length || !select[0].options || select[0].selectedIndex < 0) {
        return;
    }

    var option = jQuery(select[0].options[select[0].selectedIndex]);
    var totalPriceMoney = option.attr('data-total-price-money') || '';
    var totalCompareMoney = option.attr('data-total-compare-money') || '';
    var discountPct = option.attr('data-total-discount-pct') || '';
    var discountPercent = normalizeDiscountPercent(discountPct);
    var savePrefix = wrapper.attr('data-v4-save-prefix') || 'Save';

    var currentPrice = wrapper.find('.js-ampm-bundle-current-price').first();
    if (currentPrice.length && totalPriceMoney) {
        currentPrice.text(totalPriceMoney);
    }

    var comparePrice = wrapper.find('.js-ampm-bundle-compare-price').first();
    if (comparePrice.length) {
        if (totalCompareMoney && totalCompareMoney !== totalPriceMoney) {
            comparePrice.text(totalCompareMoney).show();
        } else {
            comparePrice.text('').hide();
        }
    }

    var savePill = wrapper.find('.js-atc-v4-save-pill').first();
    if (savePill.length) {
        var savePillText = savePill.find('.js-atc-v4-save-pill-text').first();
        if (discountPercent) {
            var nextLabel = '';
            if (templateHasDiscountToken(savePrefix)) {
                nextLabel = applyDiscountTemplateValue(savePrefix, discountPercent);
            } else {
                nextLabel = (savePrefix ? savePrefix + ' ' : '') + discountPercent;
            }
            if (savePillText.length) {
                savePillText.text(nextLabel);
            } else {
                savePill.text(nextLabel);
            }
            savePill.show();
        } else {
            if (savePillText.length) {
                savePillText.text('');
            } else {
                savePill.text('');
            }
            savePill.hide();
        }
    }

    var buttonPrice = wrapper.find('.js-atc-v4-button-price').first();
    if (buttonPrice.length && totalPriceMoney) {
        buttonPrice.text(totalPriceMoney);
    }

    applyDiscountTemplates(wrapper, discountPercent, {
        activeDiscount: discountPercent,
        ampmDiscount: discountPercent
    });
}

function cacheAtcSubV2BaseState(wrapper) {
    if (!wrapper || !wrapper.length || wrapper.attr('data-v2-base-cached') === 'true') {
        return;
    }

    wrapper.find('.price_subscription_trigger.subscription_prices_main .subscription_prices_item').each(function () {
        var item = jQuery(this);
        var priceElm = item.find('.product_price_custom').first();
        var compareElm = item.find('.product_compareprice_custom').first();
            var saveElm = item.find('.product_compareprice_custom_save').first();
            item.attr('data-v2-base-price', priceElm.text().trim());
            item.attr('data-v2-base-compare', compareElm.text().trim());
            item.attr('data-v2-base-save', saveElm.text().trim());
    });

    wrapper.find('.price_subscription_trigger.single_prices_main .single_price_item').each(function () {
        var item = jQuery(this);
        var priceElm = item.find('.product_price_custom').first();
        var compareElm = item.find('.product_compareprice_custom').first();
        item.attr('data-v2-base-price', priceElm.text().trim());
        item.attr('data-v2-base-compare', compareElm.text().trim());
    });

    var oneTimeCardPrice = wrapper.find('.js-one-time-card .custom_widget_subscription_one_time-price').first();
    if (oneTimeCardPrice.length && !oneTimeCardPrice.attr('data-v2-base-html')) {
        oneTimeCardPrice.attr('data-v2-base-html', oneTimeCardPrice.html());
    }

    wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item').each(function () {
        var item = jQuery(this);
        item.attr('data-v2-base-variant-id', item.attr('variant_id') || '');
        item.attr('data-v2-base-selling-plan', item.attr('selling_plan') || '');
        item.attr('data-v2-base-per-day', item.attr('data-per-day') || '');
    });

    wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member').not('.months').first().find('.subscription_heading_member_item').each(function () {
        var item = jQuery(this);
        item.attr('data-v2-base-save-label', item.find('span').text().trim());
    });

    wrapper.attr('data-v2-base-cached', 'true');
}

function updateAtcSubV2OneTimeBundlePrice(wrapper, priceMoney, compareMoney) {
    if (!wrapper || !wrapper.length) {
        return;
    }

    wrapper.find('.price_subscription_trigger.single_prices_main .single_price_item').each(function () {
        var item = jQuery(this);
        var priceElm = item.find('.product_price_custom').first();
        var compareElm = item.find('.product_compareprice_custom').first();

        if (priceMoney) {
            priceElm.text(priceMoney);
        }
        if (compareMoney && compareMoney !== priceMoney) {
            compareElm.text(compareMoney).show();
        } else {
            compareElm.text('').hide();
        }
    });

    var oneTimeCardPrice = wrapper.find('.js-one-time-card .custom_widget_subscription_one_time-price').first();
    if (!oneTimeCardPrice.length) {
        return;
    }

    var nextHtml = '';
    if (compareMoney && compareMoney !== priceMoney) {
        nextHtml += '<span class="product_compareprice_custom money">' + compareMoney + '</span>';
    }
    nextHtml += '<span class="product_price_custom money">' + priceMoney + '</span>';
    oneTimeCardPrice.html(nextHtml);
}

function getAmpmBundleSelectedPriceData(wrapper) {
    if (!wrapper || !wrapper.length) {
        return null;
    }

    var select = wrapper.find('.js-ampm-bundle-interval').first();
    if (!select.length || !select[0] || !select[0].options || !select[0].options.length) {
        return null;
    }

    var selectedIndex = select[0].selectedIndex >= 0 ? select[0].selectedIndex : 0;
    var option = jQuery(select[0].options[selectedIndex] || select[0].options[0]);
    if (!option.length) {
        return null;
    }

    return {
        priceMoney: option.attr('data-total-one-time-price-money') || '',
        compareMoney: option.attr('data-total-one-time-compare-money') || ''
    };
}

function applyAtcSubV2AmpmState(wrapper) {
    var primaryIntervalSelect = wrapper.find('.js-ampm-bundle-interval').first();
    var options = primaryIntervalSelect.find('option');
    if (!options.length) {
        return;
    }

    options.each(function () {
        var option = jQuery(this);
        var tab = option.attr('data-tab');
        if (!tab) return;

        var priceMoney = option.attr('data-total-price-money') || '';
        var compareMoney = option.attr('data-total-compare-money') || '';
        var discountPct = option.attr('data-total-discount-pct') || '';
        var perDay = option.attr('data-total-per-day') || '';
        var variantId = option.attr('data-main-variant-id') || '';
        var sellingPlanId = option.attr('data-main-selling-plan-id') || '';

        wrapper.find('.price_subscription_trigger.subscription_prices_main .subscription_prices_item[data_tab="' + tab + '"]').each(function () {
            var priceItem = jQuery(this);
            var priceElm = priceItem.find('.product_price_custom').first();
            var compareElm = priceItem.find('.product_compareprice_custom').first();
            var saveElm = priceItem.find('.product_compareprice_custom_save').first();
            if (priceMoney) {
                priceElm.text(priceMoney);
            }
            if (compareMoney && compareMoney !== priceMoney) {
                compareElm.text(compareMoney).show();
            } else {
                compareElm.text('').hide();
            }
            if (discountPct !== '') {
                saveElm.text('Save ' + discountPct + '%');
            }
        });

        var durationItem = wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item[data_tab="' + tab + '"]');
        if (durationItem.length) {
            durationItem.attr('variant_id', variantId);
            durationItem.attr('selling_plan', sellingPlanId);
            durationItem.attr('data-per-day', perDay);
        }

        var saveLabelItem = wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member').not('.months').first().find('.subscription_heading_member_item[data_tab="' + tab + '"] span');
        if (saveLabelItem.length && discountPct !== '') {
            saveLabelItem.text('Save ' + discountPct + '%');
        }
    });

    var selectedPriceData = getAmpmBundleSelectedPriceData(wrapper);
    if (selectedPriceData) {
        updateAtcSubV2OneTimeBundlePrice(wrapper, selectedPriceData.priceMoney, selectedPriceData.compareMoney);
    }
}

function restoreAtcSubV2BaseState(wrapper) {
    wrapper.find('.price_subscription_trigger.subscription_prices_main .subscription_prices_item').each(function () {
        var item = jQuery(this);
        var priceElm = item.find('.product_price_custom').first();
        var compareElm = item.find('.product_compareprice_custom').first();
        var saveElm = item.find('.product_compareprice_custom_save').first();
        var basePrice = item.attr('data-v2-base-price') || '';
        var baseCompare = item.attr('data-v2-base-compare') || '';
        var baseSave = item.attr('data-v2-base-save') || '';

        if (basePrice) {
            priceElm.text(basePrice);
        }
        if (baseCompare) {
            compareElm.text(baseCompare).show();
        } else {
            compareElm.text('').hide();
        }
        if (baseSave) {
            saveElm.text(baseSave);
        }
    });

    wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item').each(function () {
        var item = jQuery(this);
        item.attr('variant_id', item.attr('data-v2-base-variant-id') || item.attr('variant_id'));
        item.attr('selling_plan', item.attr('data-v2-base-selling-plan') || item.attr('selling_plan'));
        item.attr('data-per-day', item.attr('data-v2-base-per-day') || item.attr('data-per-day'));
    });

    wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member').not('.months').first().find('.subscription_heading_member_item').each(function () {
        var item = jQuery(this);
        var label = item.attr('data-v2-base-save-label');
        if (label) {
            item.find('span').text(label);
        }
    });

    wrapper.find('.price_subscription_trigger.single_prices_main .single_price_item').each(function () {
        var item = jQuery(this);
        var priceElm = item.find('.product_price_custom').first();
        var compareElm = item.find('.product_compareprice_custom').first();
        var basePrice = item.attr('data-v2-base-price') || '';
        var baseCompare = item.attr('data-v2-base-compare') || '';

        if (basePrice) {
            priceElm.text(basePrice);
        }
        if (baseCompare) {
            compareElm.text(baseCompare).show();
        } else {
            compareElm.text('').hide();
        }
    });

    var oneTimeCardPrice = wrapper.find('.js-one-time-card .custom_widget_subscription_one_time-price').first();
    if (oneTimeCardPrice.length) {
        var baseHtml = oneTimeCardPrice.attr('data-v2-base-html');
        if (typeof baseHtml === 'string' && baseHtml.length) {
            oneTimeCardPrice.html(baseHtml);
        }
    }
}

function toggleAtcSubV2TextContent(wrapper, activeTab) {
    if (!wrapper || !wrapper.length || !wrapper.hasClass('js-atc-sub-v2')) {
        return;
    }

    if (!activeTab) {
        activeTab = '1';
    }

    var detailsContainer = wrapper.find('.custom_widget_subscription_content[data_tab="1"]');
    if (!detailsContainer.length) {
        return;
    }

    var hasAmpmMode = wrapper.hasClass('is-v2-ampm-active');
    var ampmBenefits = detailsContainer.find('.js-v2-ampm-benefits');

    detailsContainer.find('.subscription_heading_member_content').hide();

    if (hasAmpmMode && ampmBenefits.length) {
        ampmBenefits.show();
        return;
    }

    if (detailsContainer.find('.subscription_heading_member_content[data_tab="' + activeTab + '"]').length) {
        detailsContainer.find('.subscription_heading_member_content[data_tab="' + activeTab + '"]').show();
    }
}

function getAtcSubV2ActiveDurationTab(wrapper) {
    if (!wrapper || !wrapper.length) {
        return '1';
    }

    var activeTab = wrapper
        .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item.active[data_tab]')
        .first()
        .attr('data_tab');
    if (activeTab) {
        return String(activeTab);
    }

    var firstTab = wrapper
        .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item[data_tab]')
        .first()
        .attr('data_tab');
    return String(firstTab || '1');
}

function syncAtcSubV2BundleIntervals(wrapper, targetTab, triggerPrimaryChange) {
    if (!wrapper || !wrapper.length) {
        return;
    }

    var tab = String(targetTab || getAtcSubV2ActiveDurationTab(wrapper) || '1');
    var selects = wrapper.find('.js-ampm-bundle-interval');
    if (!selects.length) {
        return;
    }

    var primaryTriggered = false;
    selects.each(function () {
        var select = jQuery(this);
        var option = select.find('option[data-tab="' + tab + '"]').first();
        if (!option.length) {
            return;
        }

        select.val(option.val());
        if (triggerPrimaryChange && !primaryTriggered) {
            primaryTriggered = true;
            select.trigger('change');
        }
    });
}

function toggleAtcSubV3MonthsRow(wrapper, shouldHide) {
    if (!wrapper || !wrapper.length || !wrapper.hasClass('custom_boc_subscripe_full--v3')) {
        return;
    }

    var swatchRows = wrapper.find('.custom_widget_subscription_content[data_tab="1"] > .subscription_heading_member');
    if (!swatchRows.length) {
        return;
    }

    swatchRows.each(function () {
        var row = jQuery(this);
        if (shouldHide) {
            row.attr('hidden', 'hidden');
            if (this.style && typeof this.style.setProperty === 'function') {
                this.style.setProperty('display', 'none', 'important');
            } else {
                row.css('display', 'none');
            }
            return;
        }

        row.removeAttr('hidden');
        if (this.style && typeof this.style.removeProperty === 'function') {
            this.style.removeProperty('display');
        } else {
            row.css('display', '');
        }
    });
}

function setAtcSubV2Mode(wrapper, isAmpm) {
    if (!wrapper || !wrapper.length) {
        return;
    }

    cacheAtcSubV2BaseState(wrapper);
    wrapper.toggleClass('is-v2-ampm-active', !!isAmpm);
    wrapper.find('.js-v2-bundle-choice').removeClass('is-active');
    wrapper.find('.js-v2-bundle-choice[data-choice="' + (isAmpm ? 'ampm' : 'rise') + '"]').addClass('is-active');

    if (isAmpm) {
        applyAtcSubV2AmpmState(wrapper);
        syncAtcSubV2BundleIntervals(wrapper, getAtcSubV2ActiveDurationTab(wrapper), true);
    } else {
        restoreAtcSubV2BaseState(wrapper);
        syncAtcSubV2BundleIntervals(wrapper, getAtcSubV2ActiveDurationTab(wrapper), false);
    }
    toggleAtcSubV3MonthsRow(wrapper, !!isAmpm);

    var subscribeHeading = wrapper.find('.custom_widget_subscription .custom_widget_subscription_heading_item[data_tab="1"]').first();
    if (subscribeHeading.length) {
        subscribeHeading.trigger('click');
    }
    if (isAmpm) {
        wrapper.find('.custom_widget_subscription_bundle .js-ampm-bundle-heading').first().addClass('active');
        syncAmpmBundleCardState(wrapper);
    } else {
        wrapper.find('.custom_widget_subscription_bundle .js-ampm-bundle-heading').first().removeClass('active');
        syncAmpmBundleCardState(wrapper);
    }
    updateAtcSubV2SubscribeLabel(wrapper);
    var activeTab = wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member_item.active[data_tab]').first().attr('data_tab') || '1';
    toggleAtcSubV2TextContent(wrapper, activeTab);
    syncStickyAtcV2Card(wrapper);
}

function initAtcSubV2(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    root.find('.js-atc-sub-v2').each(function () {
        var wrapper = jQuery(this);
        cacheAtcSubV2BaseState(wrapper);
        if (!wrapper.find('.js-v2-bundle-choice.is-active').length) {
            wrapper.find('.js-v2-bundle-choice[data-choice="rise"]').addClass('is-active');
        }
        setAtcSubV2Mode(wrapper, wrapper.hasClass('is-v2-ampm-active'));
    });
}

function initAtcSubV4(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    root.find('.js-atc-sub-v4').each(function () {
        syncAtcSubV4State(jQuery(this));
    });
}

jQuery(document).on('click', 'span.custom_widget_subscription_heading_item', function () {
    var heading = jQuery(this);
    var widgetWrapper = heading.closest('.custom_boc_subscripe_full');
    var subscriptionCard = heading.closest('.custom_widget_subscription');
    var scopedRoot = widgetWrapper.length ? widgetWrapper : subscriptionCard;
    var scopedForm = scopedRoot.find('.custom_product_add_to_carts_main form').first();
    if (!subscriptionCard.length && widgetWrapper.length) {
        subscriptionCard = widgetWrapper.find('.custom_widget_subscription').first();
    }

    var current_tab = heading.attr('data_tab');
    var selling_plan = heading.attr('selling_plan');
    var variant_id = heading.attr('variant_id');
    var keepSubscribeOpenOnOneTimeClick = widgetWrapper.attr('data-keep-subscribe-open-on-one-time-click') === 'true';
    var pinSubscribeOpen = keepSubscribeOpenOnOneTimeClick && current_tab === '2';

    if (widgetWrapper.length) {
        widgetWrapper.attr('data-selected-purchase-tab', current_tab);
        widgetWrapper.find('span.custom_widget_subscription_heading_item').removeClass('active is-open is-selected');
    } else if (subscriptionCard.length) {
        subscriptionCard.find('span.custom_widget_subscription_heading_item').removeClass('active is-open is-selected');
    } else {
        jQuery('span.custom_widget_subscription_heading_item').removeClass('active is-open is-selected');
    }

    if (pinSubscribeOpen && widgetWrapper.length) {
        var subscribeHeading = widgetWrapper.find('.custom_widget_subscription .custom_widget_subscription_heading_item[data_tab="1"]').first();
        if (subscribeHeading.length) {
            subscribeHeading.addClass('is-open');
        }
    } else {
        heading.addClass('active is-selected');
    }

    scopedRoot.find('.price_subscription_trigger').removeClass('active');

    // V1/V2/V3 safeguard: subscribe heading can be rendered without selling_plan.
    // Always derive subscription ids from the active frequency tab when tab=1 is selected.
    if (current_tab === '1' && widgetWrapper.length) {
        var activeDurationItem = widgetWrapper
            .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item.active[data_tab]')
            .first();
        if (!activeDurationItem.length) {
            activeDurationItem = widgetWrapper
                .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item[data_tab]')
                .first();
        }

        if (activeDurationItem.length) {
            var durationSellingPlan = activeDurationItem.attr('selling_plan');
            var durationVariantId = activeDurationItem.attr('variant_id');

            if (durationSellingPlan !== undefined && durationSellingPlan !== null && String(durationSellingPlan).trim() !== '') {
                selling_plan = String(durationSellingPlan);
                heading.attr('selling_plan', selling_plan);
            }
            if (durationVariantId !== undefined && durationVariantId !== null && String(durationVariantId).trim() !== '') {
                variant_id = String(durationVariantId);
                heading.attr('variant_id', variant_id);
            }
        }
    }

    if (scopedForm.length) {
        scopedForm.find('[name="id"]').val(variant_id);
    }
    if (selling_plan != "") {
        if (scopedForm.length) {
            scopedForm.find('[name="selling_plan"]').removeAttr('disabled');
            scopedForm.find('[name="selling_plan"]').val(selling_plan);
        }
    } else {
        if (scopedForm.length) {
            scopedForm.find('[name="selling_plan"]').attr('disabled', 'disabled');
            scopedForm.find('[name="selling_plan"]').val(selling_plan);
        }
    }
    syncSubscriptionContentState(widgetWrapper);
    syncBetweenOptionsTextState(widgetWrapper);
    var atcPriceTriggers = scopedRoot.find('.custom_product_add_to_carts_main .price_subscription_trigger');
    atcPriceTriggers.hide();
    atcPriceTriggers.filter('[data_tab="' + current_tab + '"]').show();
    syncAmpmBundleCardState(widgetWrapper);
    applyAtcSubPackFrequencyCopy(widgetWrapper);
    updateAtcSubV2SubscribeLabel(widgetWrapper);
    syncStickyAtcV2Card(widgetWrapper);
});

jQuery(document).on('click', '.js-one-time-card', function (event) {
    if (jQuery(event.target).closest('.custom_widget_subscription_heading_item').length) {
        return;
    }
    var toggle = jQuery(this).find('.custom_widget_subscription_heading_item');
    if (toggle.length) {
        toggle.trigger('click');
    }
});

jQuery(document).on('click', '.js-ampm-bundle-card', function (event) {
    if (jQuery(event.target).closest('.custom_widget_subscription_heading_item, .js-ampm-bundle-interval').length) {
        return;
    }
    var toggle = jQuery(this).find('.js-ampm-bundle-heading');
    if (toggle.length) {
        toggle.trigger('click');
    }
});

jQuery(document).on('change', '.js-ampm-bundle-interval', function () {
    var select = jQuery(this);
    var option = select.find('option:selected');
    if (!option.length) return;

    var card = select.closest('.js-ampm-bundle-card');
    if (!card.length) {
        card = select.closest('.js-v3-inline-bundle');
    }
    var heading = card.find('.js-ampm-bundle-heading');
    var wrapper = select.closest('.custom_boc_subscripe_full');

    var mainVariantId = option.attr('data-main-variant-id') || '';
    var mainSellingPlanId = option.attr('data-main-selling-plan-id') || '';
    var totalPriceMoney = option.attr('data-total-price-money') || '';
    var totalCompareMoney = option.attr('data-total-compare-money') || '';
    var mainTitle = option.attr('data-main-title') || '';
    var otherTitle = option.attr('data-other-title') || '';
    var mainPriceMoney = option.attr('data-main-price-money') || '';
    var otherPriceMoney = option.attr('data-other-price-money') || '';
    var mainCompareMoney = option.attr('data-main-compare-money') || '';
    var otherCompareMoney = option.attr('data-other-compare-money') || '';
    var mainImage = option.attr('data-main-image') || '';
    var otherImage = option.attr('data-other-image') || '';
    var optionTab = option.attr('data-tab') || '1';

    syncAtcSubV2BundleIntervals(wrapper, optionTab, false);

    heading.attr('variant_id', mainVariantId);
    heading.attr('selling_plan', mainSellingPlanId);

    var priceElm = card.find('.js-ampm-bundle-current-price');
    if (priceElm.length && totalPriceMoney) {
        priceElm.addClass('money');
        priceElm.text(totalPriceMoney);
    }

    var compareElm = card.find('.js-ampm-bundle-compare-price');
    if (compareElm.length) {
        compareElm.addClass('money');
        if (totalCompareMoney && totalCompareMoney !== totalPriceMoney) {
            compareElm.text(totalCompareMoney).show();
        } else {
            compareElm.text('').hide();
        }
    }

    card.find('.js-ampm-main-title').text(mainTitle);
    card.find('.js-ampm-other-title').text(otherTitle);
    card.find('.js-ampm-main-price').addClass('money').text(mainPriceMoney);
    card.find('.js-ampm-other-price').addClass('money').text(otherPriceMoney);

    var mainCompareElm = card.find('.js-ampm-main-compare');
    var otherCompareElm = card.find('.js-ampm-other-compare');
    mainCompareElm.addClass('money').text(mainCompareMoney);
    otherCompareElm.addClass('money').text(otherCompareMoney);
    if (mainCompareMoney && mainCompareMoney !== mainPriceMoney) {
        mainCompareElm.show();
    } else {
        mainCompareElm.hide();
    }
    if (otherCompareMoney && otherCompareMoney !== otherPriceMoney) {
        otherCompareElm.show();
    } else {
        otherCompareElm.hide();
    }

    if (mainImage) card.find('.js-ampm-main-image').attr('src', mainImage);
    if (otherImage) card.find('.js-ampm-other-image').attr('src', otherImage);

    if (wrapper.hasClass('js-atc-sub-v2') && wrapper.hasClass('is-v2-ampm-active')) {
        var selectedPriceData = getAmpmBundleSelectedPriceData(wrapper);
        if (selectedPriceData) {
            updateAtcSubV2OneTimeBundlePrice(wrapper, selectedPriceData.priceMoney, selectedPriceData.compareMoney);
        }
    }

    if (heading.hasClass('active') && !wrapper.hasClass('js-atc-sub-v2')) {
        heading.trigger('click');
    } else {
        wrapper.find('[name="id"]').val(mainVariantId);
        if (mainSellingPlanId !== '') {
            wrapper.find('[name="selling_plan"]').removeAttr('disabled').val(mainSellingPlanId);
        }
    }

    if (wrapper.hasClass('js-atc-sub-v2') && wrapper.hasClass('is-v2-ampm-active')) {
        var durationItem = wrapper
            .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item[data_tab="' + optionTab + '"]')
            .first();
        if (durationItem.length) {
            durationItem.trigger('click');
        } else {
            toggleAtcSubV2TextContent(wrapper, optionTab);
        }
    }

    // Guard: if a currency formatting library is present, ask it to re-scan updated money nodes.
    try {
        if (window.Currency && typeof window.Currency.convertAll === 'function') {
            window.Currency.convertAll();
        } else if (window.Shopify && window.Shopify.currency && typeof window.Shopify.currency.update === 'function') {
            window.Shopify.currency.update();
        }
    } catch (e) {}

    updateAtcSubV2SubscribeLabel(wrapper);
    syncAtcSubV4State(wrapper);
    applyAtcSubPackFrequencyCopy(wrapper);
    syncStickyAtcV2Card(wrapper);
});

jQuery(document).on('click', '.js-v2-bundle-choice', function () {
    var choice = jQuery(this).attr('data-choice');
    var wrapper = jQuery(this).closest('.js-atc-sub-v2');
    setAtcSubV2Mode(wrapper, choice === 'ampm');
});

function initArticleMobileGallery(scope) {
    var root = scope && scope.nodeType ? scope : document;
    var sections = root.querySelectorAll
        ? root.querySelectorAll('.main-product[data-ui-component="Product Details Article Section"]')
        : [];

    sections.forEach(function (section) {
        var mediaWrapper = section.querySelector('.product__media-wrapper--single-with-thumbnails');
        if (!mediaWrapper) {
            return;
        }

        var slider = mediaWrapper.querySelector('.product-slideshow__items');
        if (!slider) {
            return;
        }

        var prevButton = mediaWrapper.querySelector('.js-carousel-prev-btn');
        var nextButton = mediaWrapper.querySelector('.js-carousel-next-btn');
        var counterCurrent = mediaWrapper.querySelectorAll('.js-carousel-counter-current');
        var counterTotal = mediaWrapper.querySelectorAll('.js-carousel-counter-total');
        var dotsContainer = mediaWrapper.querySelector('[data-swipe-dots]');

        function getSlides() {
            return Array.prototype.filter.call(
                slider.querySelectorAll('.product-slideshow__item--mobile, .product-slideshow__item--shared'),
                function (slide) {
                    return window.getComputedStyle(slide).display !== 'none';
                }
            );
        }

        function getCurrentIndex(slides) {
            if (!slides.length) {
                return 0;
            }

            var sliderRect = slider.getBoundingClientRect();
            var bestIndex = 0;
            var bestOffset = Infinity;

            slides.forEach(function (slide, index) {
                var offset = Math.abs(slide.getBoundingClientRect().left - sliderRect.left);
                if (offset < bestOffset) {
                    bestOffset = offset;
                    bestIndex = index;
                }
            });

            return bestIndex;
        }

        function buildDots(slides) {
            if (!dotsContainer) {
                return;
            }

            dotsContainer.innerHTML = '';

            slides.forEach(function (_, index) {
                var dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'pdp-gallery-dot';
                dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
                dot.addEventListener('click', function () {
                    slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                });
                dotsContainer.appendChild(dot);
            });
        }

        function updateUi() {
            var slides = getSlides();
            if (!slides.length) {
                return;
            }

            var currentIndex = getCurrentIndex(slides);
            var total = slides.length;

            counterCurrent.forEach(function (node) {
                node.textContent = String(currentIndex + 1);
            });
            counterTotal.forEach(function (node) {
                node.textContent = String(total);
            });

            if (prevButton) {
                prevButton.disabled = currentIndex === 0;
            }
            if (nextButton) {
                nextButton.disabled = currentIndex >= total - 1;
            }

            if (dotsContainer) {
                Array.prototype.forEach.call(dotsContainer.children, function (dot, index) {
                    dot.classList.toggle('is-active', index === currentIndex);
                });
            }
        }

        function scrollByStep(direction) {
            var slides = getSlides();
            if (!slides.length) {
                return;
            }

            var currentIndex = getCurrentIndex(slides);
            var nextIndex = currentIndex + direction;
            if (nextIndex < 0) {
                nextIndex = 0;
            }
            if (nextIndex > slides.length - 1) {
                nextIndex = slides.length - 1;
            }

            slides[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }

        if (!slider.dataset.articleMobileGalleryBound) {
            slider.dataset.articleMobileGalleryBound = 'true';

            slider.addEventListener('scroll', function () {
                window.requestAnimationFrame(updateUi);
            }, { passive: true });

            if (prevButton) {
                prevButton.addEventListener('click', function (event) {
                    if (window.innerWidth >= 750) {
                        return;
                    }
                    event.preventDefault();
                    scrollByStep(-1);
                });
            }

            if (nextButton) {
                nextButton.addEventListener('click', function (event) {
                    if (window.innerWidth >= 750) {
                        return;
                    }
                    event.preventDefault();
                    scrollByStep(1);
                });
            }
        }

        var slides = getSlides();
        buildDots(slides);
        updateUi();
    });
}

jQuery(function () {
    jQuery('.js-ampm-bundle-interval').each(function () {
        jQuery(this).trigger('change');
    });
    syncAmpmBundleCardState(jQuery(document));
    syncSubscriptionContentState(jQuery(document));
    syncBetweenOptionsTextState(jQuery(document));
    applyAtcSubPackFrequencyCopy(jQuery(document));
    initAtcSubV2(jQuery(document));
    initAtcSubV4(jQuery(document));
    syncStickyAtcV2Card(jQuery(document));
    initArticleMobileGallery(document);
});

jQuery(document).on('shopify:section:load', function () {
    jQuery('.js-ampm-bundle-interval').each(function () {
        jQuery(this).trigger('change');
    });
    syncAmpmBundleCardState(jQuery(document));
    syncSubscriptionContentState(jQuery(document));
    syncBetweenOptionsTextState(jQuery(document));
    applyAtcSubPackFrequencyCopy(jQuery(document));
    initAtcSubV2(jQuery(document));
    initAtcSubV4(jQuery(document));
    syncStickyAtcV2Card(jQuery(document));
    initArticleMobileGallery(document);
});

// Keep helper text visibility in sync even when third-party scripts toggle classes without click events.
(function () {
    if (!document.body || !document.body.classList.contains('template-product')) {
        return;
    }

    var observer = new MutationObserver(function (mutations) {
        var shouldSync = false;
        for (var i = 0; i < mutations.length; i++) {
            var m = mutations[i];
            if (m.type === 'attributes' && m.attributeName === 'class') {
                var target = m.target;
                if (target && target.classList && target.classList.contains('custom_widget_subscription_heading_item')) {
                    shouldSync = true;
                    break;
                }
            }
        }
        if (shouldSync) {
            syncBetweenOptionsTextState(jQuery(document));
        }
    });

    observer.observe(document.documentElement, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });
})();

// Remove legacy Ka-ching app embed from PDP; custom AM/PM widget replaces it.
(function () {
    if (!document.body || !document.body.classList.contains('template-product')) {
        return;
    }

    function hideLegacy(root) {
        root = root && root.querySelector ? root : document;
        var bundles = root.querySelectorAll('kaching-bundle');
        if (!bundles.length) return false;
        bundles.forEach(function (bundle) {
            if (bundle.parentNode) {
                bundle.parentNode.removeChild(bundle);
            }
        });
        return true;
    }

    function init(root) {
        if (hideLegacy(root)) return;
        var obs = new MutationObserver(function () {
            if (hideLegacy(root)) obs.disconnect();
        });
        obs.observe(document.documentElement, { childList: true, subtree: true });
        window.setTimeout(function () { obs.disconnect(); }, 8000);
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (event) { init(event.target || document); });
})();

// AM/PM custom bundle add-to-cart: submit two items through existing AJAX cart flow.
(function () {
    function getCustomAmpmBundleState(root, form) {
        root = root || document;
        var scopedWrapper = null;

        if (form && form.closest) {
            scopedWrapper = form.closest('.custom_boc_subscripe_full');
            if (scopedWrapper) {
                root = scopedWrapper;
                var scopedHeading = scopedWrapper.querySelector('.custom_widget_subscription_heading_item.active[data_tab="3"]');
                var scopedSelectedTab = getSelectedPurchaseTab(jQuery(scopedWrapper), jQuery(scopedWrapper));
                var scopedAmpmSelected = scopedWrapper.classList.contains('is-v2-ampm-active') || !!scopedHeading;

                if (!scopedAmpmSelected) {
                    return null;
                }

                if (scopedSelectedTab !== '1' && scopedSelectedTab !== '2' && !scopedHeading) {
                    return null;
                }
            }
        }

        var activeHeading = root.querySelector('.custom_widget_subscription_heading_item.active[data_tab="3"]');
        var wrapper = scopedWrapper || (activeHeading ? activeHeading.closest('.custom_boc_subscripe_full') : root.querySelector('.custom_boc_subscripe_full'));
        if (!wrapper) return null;

        var selectedPurchaseTab = getSelectedPurchaseTab(jQuery(wrapper), jQuery(wrapper));
        var isAmpmSelected = wrapper.classList.contains('is-v2-ampm-active') || !!activeHeading;
        if (!isAmpmSelected) return null;

        var select = wrapper.querySelector('.js-ampm-bundle-interval');
        if (!select || !select.options || select.selectedIndex < 0) return null;

        var option = select.options[select.selectedIndex];
        var mainVariantId = parseInt(option.getAttribute('data-main-variant-id') || '', 10);
        var otherVariantId = parseInt(option.getAttribute('data-other-variant-id') || '', 10);
        if (!Number.isFinite(mainVariantId) || !Number.isFinite(otherVariantId)) return null;

        var mainSellingPlanId = parseInt(option.getAttribute('data-main-selling-plan-id') || '', 10);
        if (!Number.isFinite(mainSellingPlanId)) mainSellingPlanId = null;
        var otherSellingPlanId = parseInt(option.getAttribute('data-other-selling-plan-id') || '', 10);
        if (!Number.isFinite(otherSellingPlanId)) otherSellingPlanId = null;

        if (selectedPurchaseTab === '2') {
            mainSellingPlanId = null;
            otherSellingPlanId = null;
        }

        return {
            currentVariantId: mainVariantId,
            otherVariantId: otherVariantId,
            mainSellingPlanId: mainSellingPlanId,
            otherSellingPlanId: otherSellingPlanId,
            selectedPurchaseTab: selectedPurchaseTab,
        };
    }

    function isAmpmBundleCartLine(item) {
        if (!item || typeof item !== 'object') return false;
        var properties = item.properties || {};
        var marker = properties._ampm_bundle;
        if (marker === true) return true;
        if (typeof marker === 'string') {
            var normalized = marker.trim().toLowerCase();
            return normalized === 'true' || normalized === '1' || normalized === 'yes';
        }
        return false;
    }

    function purgeSingleCartLinesForBundle(bundleState) {
        if (!bundleState) return Promise.resolve();

        var variantIds = [parseInt(bundleState.currentVariantId || '', 10), parseInt(bundleState.otherVariantId || '', 10)].filter(function (id) {
            return Number.isFinite(id) && id > 0;
        });
        if (!variantIds.length) {
            return Promise.resolve();
        }

        var variantIdMap = {};
        variantIds.forEach(function (id) { variantIdMap[id] = true; });

        var cartUrlBase = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        var cartUrl = /\\.js$/.test(cartUrlBase) ? cartUrlBase : cartUrlBase + '.js';
        var cartChangeUrlBase = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change';
        var cartChangeUrl = /\\.js$/.test(cartChangeUrlBase) ? cartChangeUrlBase : cartChangeUrlBase + '.js';

        return fetch(cartUrl, { credentials: 'same-origin' })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Failed to fetch cart state');
                }
                return response.json();
            })
            .then(function (cart) {
                if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
                    return [];
                }

                var lineKeysToRemove = [];
                cart.items.forEach(function (item) {
                    var variantId = parseInt(item.variant_id || '', 10);
                    if (!Number.isFinite(variantId) || !variantIdMap[variantId]) {
                        return;
                    }
                    if (isAmpmBundleCartLine(item)) {
                        return;
                    }
                    if (item.key) {
                        lineKeysToRemove.push(String(item.key));
                    }
                });
                return lineKeysToRemove;
            })
            .then(function (lineKeysToRemove) {
                if (!lineKeysToRemove || !lineKeysToRemove.length) {
                    return;
                }

                var removeRequests = lineKeysToRemove.map(function (lineKey) {
                    return fetch(cartChangeUrl, {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            id: lineKey,
                            quantity: 0
                        })
                    }).then(function (response) {
                        if (!response.ok) {
                            throw new Error('Failed to remove single-product line');
                        }
                        return response.json();
                    });
                });

                return Promise.all(removeRequests);
            })
            .catch(function (error) {
                // Best-effort clean-up; if it fails we still proceed with the add flow.
                console.warn('AM/PM pre-add cart clean-up failed', error);
            });
    }

    function submitBundleAdd(host, form, bundleState) {
        if (!host || !form || !bundleState) return;
        if (host.elms && host.elms.submit_btn && host.elms.submit_btn.classList.contains('loading')) return;

        if (host.handleErrorMessage) host.handleErrorMessage();
        if (host.elms && host.elms.submit_btn) {
            host.elms.submit_btn.setAttribute('aria-disabled', true);
            host.elms.submit_btn.classList.add('loading');
        }
        if (host.elms && host.elms.spinner) host.elms.spinner.classList.remove('hidden');

        var sectionsToRender = [];
        if (host.cartNotification && host.cartNotification.getSectionsToRender) {
            sectionsToRender = host.cartNotification.getSectionsToRender();
        }
        if (host.cartDrawer && host.cartDrawer.getSectionsToRender) {
            sectionsToRender = sectionsToRender.concat(host.cartDrawer.getSectionsToRender());
        }

        var formData = new FormData(form);
        var qty = parseInt(formData.get('quantity') || '1', 10);
        if (!Number.isFinite(qty) || qty <= 0) qty = 1;

        var mainVariantId = bundleState.currentVariantId || parseInt(formData.get('id') || '', 10);
        var otherVariantId = bundleState.otherVariantId;
        if (!mainVariantId || !otherVariantId) {
            if (host.elms && host.elms.submit_btn) {
                host.elms.submit_btn.classList.remove('loading');
                host.elms.submit_btn.removeAttribute('aria-disabled');
            }
            if (host.elms && host.elms.spinner) host.elms.spinner.classList.add('hidden');
            return;
        }

        var sellingPlanId = bundleState.mainSellingPlanId || formData.get('selling_plan');
        var isSubscription = !!sellingPlanId;

        formData.delete('id');
        formData.delete('quantity');
        formData.delete('selling_plan');
        formData.delete('properties[__kaching_bundles]');

        formData.append('items[0][id]', String(mainVariantId));
        formData.append('items[0][quantity]', String(qty));
        if (isSubscription) {
            formData.append('items[0][selling_plan]', String(sellingPlanId));
        }
        formData.append('items[0][properties][_ampm_bundle]', 'true');
        formData.append('items[0][properties][_ampm_bundle_role]', 'main');

        formData.append('items[1][id]', String(otherVariantId));
        formData.append('items[1][quantity]', String(qty));
        if (bundleState.otherSellingPlanId) {
            formData.append('items[1][selling_plan]', String(bundleState.otherSellingPlanId));
        }
        formData.append('items[1][properties][_ampm_bundle]', 'true');
        formData.append('items[1][properties][_ampm_bundle_role]', 'other');

        if (sectionsToRender.length) formData.append('sections', sectionsToRender.map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);

        var cfg = (window.SHTHelper && window.SHTHelper.fetchConfigHTTP) ? window.SHTHelper.fetchConfigHTTP : { method: 'POST' };
        cfg = Object.assign({}, cfg, { body: formData });

        function closeBogosPopup() {
            var closeSelectors = [
                '.bogos-slider-close-btn',
                '#freegifts-main-popup-container .bogos-slider-close-btn',
                '.bogos-shopify-block .bogos-slider-close-btn',
                '.bogos-shopify-block [class*="close"]'
            ];
            closeSelectors.forEach(function (selector) {
                var btn = document.querySelector(selector);
                if (btn) {
                    try { btn.click(); } catch (e) {}
                }
            });

            var containers = document.querySelectorAll(
                '#freegifts-main-popup-container, .bogos-shopify-block, .bogos-gift-slider, .bogos-gift-popup'
            );
            containers.forEach(function (container) {
                if (!container) return;
                container.classList.remove('sca-is-visible-fg');
                container.setAttribute('aria-hidden', 'true');
                if (container.id === 'freegifts-main-popup-container') {
                    container.style.display = 'none';
                }
            });
        }

        purgeSingleCartLinesForBundle(bundleState)
            .then(function () {
                return fetch('' + (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add'), cfg);
            })
            .then(function (r) { return r.json(); })
            .then(function (t) {
                if (t && t.status) {
                    if (host.handleErrorMessage) host.handleErrorMessage(t.description);
                    return;
                }

                if (host.elms && host.elms.sticky_header && host.elms.sticky_header.dataset.isEnabled && host.elms.sticky_header.reveal) {
                    host.elms.sticky_header.reveal();
                }

                var hasSectionsPayload = !!(t && t.sections && typeof t.sections === 'object');
                if (hasSectionsPayload && host.cartNotification && host.cartNotification.renderContents) {
                    try { host.cartNotification.renderContents(t); } catch (e) {}
                }
                if (hasSectionsPayload && host.cartDrawerForm && host.cartDrawerForm.renderContents) {
                    try { host.cartDrawerForm.renderContents(t); } catch (e) {}
                }

                window.setTimeout(function () {
                    var opener =
                        (window.SHTHelper && window.SHTHelper.qs && window.SHTHelper.qs('.js-header-cart-status-btn')) ||
                        (host.elms && host.elms.submit_btn);
                    var drawer = host.cartDrawer || document.querySelector('sht-cart-drwr');

                    var attempts = 0;
                    var interval = window.setInterval(function () {
                        attempts += 1;
                        closeBogosPopup();

                        try {
                            if (drawer && drawer.openDrawer) drawer.openDrawer(opener);
                        } catch (e) {}

                        if (attempts >= 6) window.clearInterval(interval);
                    }, 200);
                }, 50);
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
                if (host.elms && host.elms.submit_btn) {
                    host.elms.submit_btn.classList.remove('loading');
                    host.elms.submit_btn.removeAttribute('aria-disabled');
                }
                if (host.elms && host.elms.spinner) host.elms.spinner.classList.add('hidden');
            });
    }

    document.addEventListener('submit', function (e) {
        try {
            var form = e.target;
            if (!form || form.tagName !== 'FORM') return;
            if (!form.closest('.custom_product_add_to_carts_main')) return;

            var host = form.closest('sht-prd-frm');
            if (!host) return;

            var root = (host.closest && host.closest('.shopify-section')) || document;
            var bundleState = getCustomAmpmBundleState(root, form);
            if (!bundleState) return;

            e.preventDefault();
            e.stopImmediatePropagation();
            submitBundleAdd(host, form, bundleState);
        } catch (err) {}
    }, true);
})();



// Sync subscription benefits with the currently selected variant.
jQuery(document).on('change', '.js-variant-radio-item, .js-variant-select-item', function () {
    var form = jQuery(this).closest('form');
    var variantId = form.find('[name="id"]').val();
    if (!variantId) {
        return;
    }
    var wrapper = form.closest('.custom_boc_subscripe_full');
    if (!wrapper.length) {
        return;
    }
    var subscriptionCard = wrapper.find('.custom_widget_subscription');
    if (!subscriptionCard.length) return;
    var matchingTab = subscriptionCard.find('.subscription_heading_member_item[variant_id="' + variantId + '"]');
    if (matchingTab.length) {
        matchingTab.first().trigger('click');
    }
});

jQuery(document).on('click', 'span.subscription_heading_member_item', function () {
    var item = jQuery(this);
    var current_tab = item.attr('data_tab');
    var subscriptionCard = item.closest('.custom_widget_subscription');
    var wrapper = item.closest('.custom_boc_subscripe_full');
    var scopedForm = wrapper.find('.custom_product_add_to_carts_main form').first();

    subscriptionCard.find('span.subscription_heading_member_item').removeClass('active');
    subscriptionCard.find('.subscription_heading_member_item[data_tab="' + current_tab + '"]').addClass('active');
    subscriptionCard.find('.subscription_heading_member_content').hide();
    subscriptionCard.find('.subscription_heading_member_content[data_tab="' + current_tab + '"]').show();
    subscriptionCard.find('.subscription_prices_item').removeClass('active');
    subscriptionCard.find('.subscription_prices_item[data_tab="' + current_tab + '"]').addClass('active');
    subscriptionCard.find('.subscription_prices_item').hide();
    subscriptionCard.find('.subscription_prices_item[data_tab="' + current_tab + '"]').show();
    toggleAtcSubV2TextContent(wrapper, current_tab);

    var selling_plan = item.attr('selling_plan');
    var variant_id = item.attr('variant_id');
    subscriptionCard.find('.custom_widget_subscription_heading_item[data_tab="1"]').attr('variant_id', variant_id);
    subscriptionCard.find('.custom_widget_subscription_heading_item[data_tab="1"]').attr('selling_plan', selling_plan);
    if (scopedForm.length) {
        scopedForm.find('[name="id"]').val(variant_id);
        scopedForm.find('[name="selling_plan"]').removeAttr('disabled');
        scopedForm.find('[name="selling_plan"]').val(selling_plan);
    }

    syncAtcSubV2BundleIntervals(wrapper, current_tab, false);

    applyAtcSubPackFrequencyCopy(wrapper);
    updateAtcSubV2SubscribeLabel(wrapper);
    syncStickyAtcV2Card(wrapper);
});


/*

jQuery("span.custom_widget_subscription_heading_item:nth-child(2)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
jQuery('.variants_custom li:nth-child(1) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
setTimeout(function () {
  jQuery('.product__info.product__prices').removeClass('updating');
  window.history.replaceState(null, '', window.location.pathname);
}, 1000);
//jQuery('input[name="quantity"]').val('1');

});
jQuery("span.custom_widget_subscription_heading_item:nth-child(1)").click(function() {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
jQuery('.subscription_heading_member_item:nth-child(1').trigger('click');
});

jQuery(".subscription_heading_member_item:nth-child(1)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.variants_custom li:nth-child(1) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
jQuery('.appstle_subscription_radio_wrapper').trigger('click');
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
}, 1000);
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
  jQuery('.product__info.product__prices').removeClass('updating');
}, 1500);
});
jQuery(".subscription_heading_member_item:nth-child(2)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.variants_custom li:nth-child(2) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
jQuery('.appstle_subscription_radio_wrapper').trigger('click');
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
}, 1000);
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
  jQuery('.product__info.product__prices').removeClass('updating');
}, 1500);
});
jQuery(".subscription_heading_member_item:nth-child(3)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.variants_custom li:nth-child(3) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
jQuery('.appstle_subscription_radio_wrapper').trigger('click');
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
}, 1000);
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
  jQuery('.product__info.product__prices').removeClass('updating');
}, 1500);
});
*/


$(document).on("click", ".header__icons.header__icons--right .btn-icon.btn-search", function (e) {
    var openDrawer = document.querySelector('.header-v2__drawer.is-open');
    if (openDrawer) {
        var drawerClose = openDrawer.querySelector('[data-header-drawer-close]');
        if (drawerClose) {
            drawerClose.click();
        } else {
            openDrawer.classList.remove('is-open');
            openDrawer.hidden = true;
            document.body.classList.remove('header-v2--drawer-open');
        }
    } else if (document.body.classList.contains('header-v2--drawer-open')) {
        document.body.classList.remove('header-v2--drawer-open');
    }
    jQuery('sht-header').addClass('header--predictive-search-open');
    document.body.classList.add('search-open');
});

$(document).on("click", ".js-drawer-search-trigger", function (e) {
    e.preventDefault();
    var trigger = e.currentTarget;
    var openDrawer = document.querySelector('.header-v2__drawer.is-open');
    if (openDrawer) {
        var drawerClose = openDrawer.querySelector('[data-header-drawer-close]');
        if (drawerClose) {
            drawerClose.click();
        } else {
            openDrawer.classList.remove('is-open');
            openDrawer.hidden = true;
            document.body.classList.remove('header-v2--drawer-open');
        }
    } else if (document.body.classList.contains('header-v2--drawer-open')) {
        document.body.classList.remove('header-v2--drawer-open');
    }

    if (!window.SHTHelper) {
        return;
    }
    var header = document.querySelector('sht-header');
    if (!header) {
        return;
    }
    var predictiveSearchElm = header.querySelector('.js-predictive-search');
    var predictiveSearchInputElm = header.querySelector('.js-predictive-search-input');
    window.SHTHelper.loadScript(
        trigger.dataset.jsFileId,
        trigger.dataset.jsFile,
        function () {
            header.classList.add('header--predictive-search-open');
            document.body.classList.add('o-hidden');
            document.body.classList.add('search-open');
            setTimeout(function () {
                if (predictiveSearchElm && predictiveSearchInputElm) {
                    window.SHTHelper.trapFocus(predictiveSearchElm, predictiveSearchInputElm);
                }
            }, 650);
        }
    );
});

// Format Judge.me average text like "4.75 out of 5" -> "4.75/5"
// and optionally prepend rating + count in PDP badge text.
(function () {
    if (!document.body) {
        return;
    }

    var isProductTemplate = document.body.classList.contains('template-product');
    var hasJudgeElements =
        document.querySelector('.product__judgeme') ||
        document.querySelector('#judgeme_product_reviews') ||
        document.querySelector('.jdgm-rev-widg');
    if (!isProductTemplate && !hasJudgeElements) {
        return;
    }

    function updateJudgeMeAverage(root) {
        var scope = root || document;
        var averageLinks = scope.querySelectorAll(
            '.jdgm-rev-widg__summary-average, .jdgm-rev-widg__summary-average a, .jdgm-prev-badge__text'
        );
        if (!averageLinks.length) {
            return;
        }
        averageLinks.forEach(function (el) {
            var text = el.textContent || '';
            if (text.indexOf(' out of ') === -1) {
                return;
            }
            el.textContent = text.replace(/\s*out of\s*/i, '/');
        });
    }

    function updateJudgeMeBadgeText(root) {
        var scope = root || document;
        var badgeBlocks = scope.querySelectorAll(
            '.product__judgeme[data-judgeme-show-rating-with-count="true"] .jdgm-prev-badge'
        );
        if (!badgeBlocks.length) {
            return;
        }
        badgeBlocks.forEach(function (badge) {
            var rating = badge.getAttribute('data-average-rating');
            var count = badge.getAttribute('data-number-of-reviews');
            if (!rating || !count) {
                return;
            }
            var ratingValue = parseFloat(rating);
            if (Number.isNaN(ratingValue)) {
                return;
            }
            var container = badge.closest('.product__judgeme');
            var separator = container && container.getAttribute('data-judgeme-separator') ? container.getAttribute('data-judgeme-separator') : ' ∙ ';
            if (!separator) {
                separator = ' ∙ ';
            }
            var textTarget = badge.querySelector('.jdgm-prev-badge__text');
            if (!textTarget) {
                return;
            }
            var displayRating = ratingValue.toFixed(1);
            var nextText = displayRating + '/5' + separator + count + ' reviews';
            if (textTarget.textContent !== nextText) {
                textTarget.textContent = nextText;
            }
        });
    }

    var pendingBadgeUpdate = false;
    function scheduleJudgeMeBadgeTextUpdate(root) {
        var scope = root || document;
        if (pendingBadgeUpdate) {
            return;
        }
        pendingBadgeUpdate = true;
        requestAnimationFrame(function () {
            pendingBadgeUpdate = false;
            updateJudgeMeAverage(scope);
            updateJudgeMeBadgeText(scope);
        });
    }

    function nodeContainsJudgeMe(node) {
        if (!node || node.nodeType !== 1) {
            return false;
        }
        if (
            node.matches &&
            node.matches('.product__judgeme, #judgeme_product_reviews, .jdgm-rev-widg, .jdgm-prev-badge')
        ) {
            return true;
        }
        return !!(
            node.querySelector &&
            node.querySelector('.product__judgeme, #judgeme_product_reviews, .jdgm-rev-widg, .jdgm-prev-badge')
        );
    }

    function scheduleJudgeMeRetries() {
        var retryDelays = [700, 1400, 2600, 4200, 6200];
        retryDelays.forEach(function (delay) {
            setTimeout(function () {
                scheduleJudgeMeBadgeTextUpdate(document);
            }, delay);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        scheduleJudgeMeBadgeTextUpdate(document);
        window.addEventListener('load', function () {
            scheduleJudgeMeBadgeTextUpdate(document);
        });
        scheduleJudgeMeRetries();

        if (typeof MutationObserver === 'undefined' || !document.body) {
            return;
        }

        var observer = new MutationObserver(function (mutations) {
            var shouldRefresh = false;
            mutations.forEach(function (mutation) {
                if (shouldRefresh || mutation.type !== 'childList' || !mutation.addedNodes.length) {
                    return;
                }
                mutation.addedNodes.forEach(function (node) {
                    if (!shouldRefresh && nodeContainsJudgeMe(node)) {
                        shouldRefresh = true;
                    }
                });
            });

            if (shouldRefresh) {
                scheduleJudgeMeBadgeTextUpdate(document);
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    });
})();

$(document).on("click", ".js-predictive-search-close-trigger", function (e) {
    jQuery('sht-header').removeClass('header--predictive-search-open');
    document.body.classList.remove('search-open');
});

(function () {
    function getHeader() {
        return document.querySelector('sht-header');
    }

    function getPredictive() {
        return document.querySelector('sht-predictive-srch');
    }

    function getSetting(name, fallback) {
        var header = getHeader();
        if (!header) {
            return fallback;
        }
        var value = header.dataset[name];
        if (value === undefined || value === "") {
            return fallback;
        }
        return value !== "false";
    }

    function isSearchOpen() {
        var header = getHeader();
        var predictive = getPredictive();
        return (
            (header && header.classList.contains('header--predictive-search-open')) ||
            (predictive && predictive.hasAttribute('open'))
        );
    }

    function isMobileViewport() {
        return window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
    }

    function shouldCloseOnScroll() {
        var closeOnScroll = getSetting('searchCloseOnScroll', true);
        if (!closeOnScroll) {
            return false;
        }
        if (isMobileViewport()) {
            return false;
        }
        return true;
    }

    function closeSearch() {
        var header = getHeader();
        var predictive = getPredictive();
        if (predictive && typeof predictive.closeSearchResults === 'function') {
            predictive.closeSearchResults(true);
        }
        if (predictive) {
            predictive.removeAttribute('open');
        }
        if (header) {
            header.classList.remove('header--predictive-search-open');
        }
        document.body.classList.remove('o-hidden');
        document.body.classList.remove('search-open');
    }

    function applyScrollBehavior() {
        var allowScroll = getSetting('searchAllowScroll', true);
        if (isSearchOpen() && allowScroll) {
            document.body.classList.remove('o-hidden');
        }
        if (isSearchOpen()) {
            document.body.classList.add('search-open');
        }
    }

    var predictive = getPredictive();
    if (predictive) {
        var predictiveObserver = new MutationObserver(function () {
            applyScrollBehavior();
        });
        predictiveObserver.observe(predictive, { attributes: true, attributeFilter: ['open'] });
    }

    var header = getHeader();
    if (header) {
        var headerObserver = new MutationObserver(function () {
            if (!shouldCloseOnScroll()) {
                return;
            }
            if (header.classList.contains('is-header-hide') && isSearchOpen()) {
                closeSearch();
            }
        });
        headerObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
    }

    jQuery(window).on("scroll", function () {
        if (!shouldCloseOnScroll()) {
            return;
        }
        if (isSearchOpen()) {
            closeSearch();
        }
    });
})();

$(document).on("click", "a.button_member.product_member_button", function (e) {
    e.preventDefault();
    $('.custom_widget_subscription_heading_item[data_tab="1"]').trigger('click');
    $('.subscription_heading_member_item[data_tab="1"]').trigger('click');
    $('.custom_product_add_to_carts_main button.js-product-form-submit-btn').trigger('click');
});

(function () {
    var accountSubscriptionsPath = '/a/account/subscriptions';
    if (window.location.pathname.indexOf(accountSubscriptionsPath) !== 0) {
        return;
    }

    var upgradeLabel = 'Upgrade Subscription';
    var emailRecipient = 'letschat@8-hours.com';
    var emailSubject = encodeURIComponent('Subscription Upgrade');
    var emailBody = encodeURIComponent(
        'Hey 8hours team, I am looking to upgrade my subscription volume/frequency to get the best price & added convenience - what are my options?'
    );
    var mailtoHref = 'mailto:' + emailRecipient + '?subject=' + emailSubject + '&body=' + emailBody;
    var observer = null;

  function ensureOverlay(row) {
    if (!row) {
      return false;
    }

    var existingOverlay = row.querySelector('a.skio-upgrade-overlay');

    function triggerMailto(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      console.log('[skio-upgrade] triggerMailto start');
      var opened = false;

      try {
        window.location.href = mailtoHref;
        opened = true;
        console.log('[skio-upgrade] window.location href navigation attempted');
      } catch (error) {
        console.warn('[skio-upgrade] window.location href failed', error);
      }

      if (!opened) {
        try {
          window.location.assign(mailtoHref);
          opened = true;
          console.log('[skio-upgrade] window.location assign attempted');
        } catch (error) {
          console.warn('[skio-upgrade] window.location assign failed', error);
        }
      }

      if (!opened) {
        try {
          var tempLink = document.createElement('a');
          tempLink.href = mailtoHref;
          tempLink.target = '_top';
          tempLink.rel = 'noopener';
          tempLink.style.display = 'none';
          document.body.appendChild(tempLink);
          tempLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          tempLink.remove();
          opened = true;
          console.log('[skio-upgrade] temp anchor dispatched');
        } catch (error) {
          console.warn('[skio-upgrade] temp anchor dispatch failed', error);
        }
      }

      if (!opened) {
        try {
          var iframe = document.createElement('iframe');
          iframe.style.position = 'absolute';
          iframe.style.width = '1px';
          iframe.style.height = '1px';
          iframe.style.opacity = '0';
          iframe.style.pointerEvents = 'none';
          iframe.src = mailtoHref;
          document.body.appendChild(iframe);
          setTimeout(function () {
            iframe.remove();
          }, 2000);
          opened = true;
          console.log('[skio-upgrade] iframe fallback attempted');
        } catch (error) {
          console.error('[skio-upgrade] iframe fallback failed', error);
        }
      }
    }

    if (existingOverlay) {
      existingOverlay.setAttribute('href', mailtoHref);
      existingOverlay.setAttribute('aria-label', upgradeLabel);
      existingOverlay.setAttribute('title', upgradeLabel);
      existingOverlay.setAttribute('target', '_top');
      existingOverlay.setAttribute('rel', 'noopener');
      existingOverlay.removeEventListener('click', triggerMailto);
      existingOverlay.addEventListener('click', triggerMailto);
      return true;
    }

    var currentPosition = window.getComputedStyle(row).position;
    if (currentPosition === 'static' || !currentPosition) {
      row.style.position = 'relative';
    }

    var overlay = document.createElement('a');
    overlay.className = 'skio-upgrade-overlay';
    overlay.href = mailtoHref;
    overlay.target = '_top';
    overlay.rel = 'noopener';
    overlay.setAttribute('aria-label', upgradeLabel);
    overlay.setAttribute('title', upgradeLabel);
    overlay.style.position = 'absolute';
    overlay.style.inset = '0';
    overlay.style.zIndex = '10';
    overlay.style.borderRadius = 'inherit';
    overlay.style.cursor = 'pointer';
    overlay.style.background = 'rgba(0, 0, 0, 0)';
    overlay.style.display = 'block';

    overlay.addEventListener('click', triggerMailto);

    row.appendChild(overlay);
    console.log('[skio-upgrade] overlay appended for row', row);

    return true;
  }

  function wireButton() {
    var rows = document.querySelectorAll('.sc-4b34317c-1');
    var rewired = false;

    rows.forEach(function (row, index) {
      var button = row.querySelector('button[aria-label="Edit products"], button[data-skio-upgrade-wired="true"]');
      var labelSpan = row.querySelector('[data-testid="typography"]');

      if (!button && !labelSpan && row.dataset.skioUpgradeApplied !== 'true') {
        return;
      }

      var labelText = labelSpan && labelSpan.textContent ? labelSpan.textContent.trim().toLowerCase() : '';
      var buttonLabel = button && button.getAttribute('aria-label');
      var matchesOriginal = (labelText === 'edit products') || (buttonLabel && buttonLabel.toLowerCase() === 'edit products');
      var alreadyUpgraded = row.dataset.skioUpgradeApplied === 'true';

      if (!matchesOriginal && !alreadyUpgraded) {
        if (index < 5) {
          console.log('[skio-upgrade] skipping row', index, 'labelText:', labelText, 'buttonLabel:', buttonLabel);
        }
        return;
      }

      if (button) {
        button.dataset.skioUpgradeWired = 'true';
        button.setAttribute('aria-label', upgradeLabel);
        button.type = 'button';
      }

      if (labelSpan) {
        labelSpan.textContent = upgradeLabel;
      }

      row.dataset.skioUpgradeApplied = 'true';

      if (ensureOverlay(row)) {
        rewired = true;
        console.log('[skio-upgrade] overlay ensured for row', index);
      }
    });

    console.log('[skio-upgrade] wireButton completed. rewired?', rewired);
    return rewired;
  }

    function initObserver() {
        if (wireButton()) {
            return;
        }

        observer = new MutationObserver(function () {
            if (wireButton() && observer) {
                observer.disconnect();
                observer = null;
            }
        });

        observer.observe(document.body, {childList: true, subtree: true});
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initObserver);
    } else {
        initObserver();
  }
})();

// Sticky PDP ATC (mobile bottom nav) -> submit main PDP form and sync loading state.
(function () {
    function isVisible(el) {
        return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
    }

    function findTargetButton() {
        var btn = document.querySelector('.custom_product_add_to_carts_main .js-product-form-submit-btn');
        if (btn && isVisible(btn)) return btn;
        var all = document.querySelectorAll('.js-product-form-submit-btn');
        for (var i = 0; i < all.length; i++) {
            if (isVisible(all[i])) return all[i];
        }
        return null;
    }

    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.trigger_cart');
        if (!trigger) return;
        if (e.stickyAtcHandled) return;
        e.stickyAtcHandled = true;
        e.preventDefault();

        var targetBtn = findTargetButton();
        if (trigger) {
            trigger.classList.add('loading');
            trigger.setAttribute('aria-disabled', 'true');
        }

        if (targetBtn) {
            var targetForm = targetBtn.closest('form');
            if (targetForm) {
                targetForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            } else {
                targetBtn.click();
            }
        }

        if (trigger && targetBtn) {
            var start = Date.now();
            var syncTimer = setInterval(function () {
                var isLoading = targetBtn.classList.contains('loading');
                if (!isLoading || Date.now() - start > 10000) {
                    trigger.classList.remove('loading');
                    trigger.removeAttribute('aria-disabled');
                    clearInterval(syncTimer);
                }
            }, 200);
        }
    });
})();

(function () {
  function getRollingLoopWidth(items, track) {
    if (!items || !items.length) return 0;
    var width = 0;
    var gapValue = 0;
    if (track) {
      var styles = window.getComputedStyle(track);
      gapValue = parseFloat(styles.columnGap || styles.gap || "0");
    }
    if (!Number.isFinite(gapValue)) {
      gapValue = 0;
    }
    items.forEach(function (item, index) {
      var rect = item.getBoundingClientRect();
      width += rect ? rect.width : item.offsetWidth || 0;
      if (index < items.length - 1) {
        width += gapValue;
      }
    });
    return Math.max(0, Math.round(width));
  }

  function cloneRollingItems(track, originals) {
    originals.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("data-rolling-clone", "true");
      Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
        if (attr && attr.name && attr.name.indexOf("data-shopify") === 0) {
          clone.removeAttribute(attr.name);
        }
      });
      track.appendChild(clone);
    });
  }

  function ensureRollingLoop(section) {
    if (!section) return;
    if (window.matchMedia("(max-width: 47.99em)").matches) return;

    var mask = section.querySelector("[data-marquee-mask]");
    var track = section.querySelector("[data-marquee-track]");
    if (!mask || !track) return;

    var maskWidth = mask.clientWidth;
    if (!maskWidth) return;

    var existingClones = track.querySelectorAll('[data-rolling-clone="true"], [aria-hidden="true"]');
    existingClones.forEach(function (node) {
      node.remove();
    });

    var originals = Array.prototype.slice.call(track.children).filter(function (item) {
      return item.getAttribute("aria-hidden") !== "true";
    });
    if (!originals.length) return;

    var loopWidth = getRollingLoopWidth(originals, track);
    if (!loopWidth) {
      if (section.dataset.rollingLoopRetry !== "true") {
        section.dataset.rollingLoopRetry = "true";
        setTimeout(function () {
          section.dataset.rollingLoopRetry = "false";
          ensureRollingLoop(section);
        }, 400);
      }
      return;
    }

    var originalsCopy = originals.slice();
    track.innerHTML = "";
    originalsCopy.forEach(function (item) {
      track.appendChild(item);
    });

    var sequenceWidth = getRollingLoopWidth(Array.prototype.slice.call(track.children), track);
    if (!sequenceWidth) {
      section.style.setProperty("--marquee-distance", loopWidth + "px");
      return;
    }

    while (sequenceWidth < maskWidth) {
      originalsCopy.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.setAttribute("data-rolling-clone", "true");
        Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
          if (attr && attr.name && attr.name.indexOf("data-shopify") === 0) {
            clone.removeAttribute(attr.name);
          }
        });
        track.appendChild(clone);
      });
      sequenceWidth = getRollingLoopWidth(Array.prototype.slice.call(track.children), track);
      if (!sequenceWidth) break;
    }

    var sequenceNodes = Array.prototype.slice.call(track.children);
    sequenceNodes.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("data-rolling-clone", "true");
      Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
        if (attr && attr.name && attr.name.indexOf("data-shopify") === 0) {
          clone.removeAttribute(attr.name);
        }
      });
      track.appendChild(clone);
    });

    var totalWidth = track.scrollWidth;
    var marqueeDistance = totalWidth ? Math.round(totalWidth / 2) : sequenceWidth;
    section.style.setProperty("--marquee-distance", marqueeDistance + "px");
  }

  function initRollingLoop(root) {
    if (!root) return;
    var sections = root.querySelectorAll(".rolling-testimonials");
    sections.forEach(function (section) {
      ensureRollingLoop(section);
      if (section.dataset.rollingResizeInit === "true") return;
      if ("ResizeObserver" in window) {
        var mask = section.querySelector("[data-marquee-mask]");
        if (mask) {
          var observer = new ResizeObserver(function () {
            ensureRollingLoop(section);
          });
          observer.observe(mask);
          section.dataset.rollingResizeInit = "true";
        }
      }
    });
  }

  var resizeTimer = null;
  function handleResize() {
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(function () {
      initRollingLoop(document);
    }, 150);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRollingLoop(document);
  });

  window.addEventListener("load", function () {
    initRollingLoop(document);
  });

  window.addEventListener("resize", handleResize);

  document.addEventListener("shopify:section:load", function (event) {
    initRollingLoop(event.target || document);
  });
})();

(function () {
  function activateRollingTestimonials(section) {
    if (!section || section.dataset.rollingAnimated === "true") return;

    var cards = section.querySelectorAll(".rolling-testimonials__item.anm");
    if (!cards.length) {
      section.dataset.rollingAnimated = "true";
      return;
    }

    function activateVisible() {
      var mask = section.querySelector("[data-marquee-mask]");
      var maskRect = mask ? mask.getBoundingClientRect() : null;
      cards.forEach(function (card) {
        var visible = true;
        if (maskRect) {
          var rect = card.getBoundingClientRect();
          visible =
            rect.right > maskRect.left &&
            rect.left < maskRect.right &&
            rect.bottom > maskRect.top &&
            rect.top < maskRect.bottom;
        }
        if (!visible) {
          card.classList.add("anm-skip");
        }
        card.classList.add("animated");
      });
      section.dataset.rollingAnimated = "true";
    }

    var mask = section.querySelector("[data-marquee-mask]");
    if (!("IntersectionObserver" in window) || !mask) {
      activateVisible();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            activateVisible();
            obs.disconnect();
            return;
          }
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(mask);
  }

  function initRollingTestimonials(root) {
    if (!root) return;
    var sections = root.querySelectorAll(".rolling-testimonials[data-rolling-animate=\"true\"]");
    sections.forEach(function (section) {
      activateRollingTestimonials(section);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRollingTestimonials(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initRollingTestimonials(event.target || document);
  });
})();

(function () {
  function initRollingTestimonialsSwipe(root) {
    if (!root) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var sections = root.querySelectorAll(".rolling-testimonials");
    sections.forEach(function (section) {
      if (section.dataset.rollingSwipeInit === "true") return;
      var useCssAuto = section.dataset.rollingCssAuto === "true";
      var pauseOnHover = section.dataset.pauseOnHover === "true";
      var stopOnInteract = window.matchMedia("(max-width: 47.99em)").matches || window.matchMedia("(pointer: coarse)").matches;
      var mask = section.querySelector("[data-marquee-mask]");
      var track = section.querySelector("[data-marquee-track]");
      if (!mask || !track) {
        section.dataset.rollingSwipeInit = "true";
        return;
      }

      if (!stopOnInteract) {
        section.dataset.rollingSwipeInit = "true";
        return;
      }

      if (useCssAuto) {
        track.style.animation = "none";
        track.style.transform = "translate3d(0, 0, 0)";
        section.dataset.rollingCssAuto = "false";
        useCssAuto = false;
      }

      function getLoopWidth() {
        var items = Array.prototype.slice.call(
          track.querySelectorAll('.rolling-testimonials__item:not([aria-hidden="true"])')
        );
        var fallbackWidth = Math.round(track.scrollWidth / 2);
        if (!items.length) return fallbackWidth;
        var styles = window.getComputedStyle(track);
        var gapValue = parseFloat(styles.columnGap || styles.gap || "0");
        if (!Number.isFinite(gapValue)) {
          gapValue = 0;
        }
        var width = 0;
        items.forEach(function (item, index) {
          var rect = item.getBoundingClientRect();
          width += rect ? rect.width : item.offsetWidth || 0;
          if (index < items.length - 1) {
            width += gapValue;
          }
        });
        return Math.max(0, Math.round(width || fallbackWidth || 0));
      }

      var loopWidth = getLoopWidth();
      if (!loopWidth) {
        if (section.dataset.rollingSwipeRetry !== "true") {
          section.dataset.rollingSwipeRetry = "true";
          setTimeout(function () {
            section.dataset.rollingSwipeRetry = "false";
            initRollingTestimonialsSwipe(root);
          }, 500);
        }
        return;
      }

      if (!section.dataset.rollingSwipePositioned) {
        mask.scrollLeft = loopWidth;
        section.dataset.rollingSwipePositioned = "true";
      }

      var speedSeconds = parseFloat(section.dataset.speedSeconds);
      if (!Number.isFinite(speedSeconds) || speedSeconds <= 0) {
        speedSeconds = 180;
      }
      var pxPerMs = loopWidth / (speedSeconds * 1000);

      function wrapScroll() {
        var maxScroll = track.scrollWidth - mask.clientWidth;
        if (mask.scrollLeft <= 1) {
          mask.scrollLeft += loopWidth;
        } else if (mask.scrollLeft >= maxScroll - 1) {
          mask.scrollLeft -= loopWidth;
        }
      }

      mask.addEventListener("scroll", wrapScroll, { passive: true });

      if (!useCssAuto && section.dataset.rollingAutoScrollInit !== "true") {
        var autoScrollActive = true;
        var autoScrollPaused = false;
        var autoScrollId = null;
        var lastTime = null;

        function updateLoopWidth() {
          var newWidth = getLoopWidth();
          if (!newWidth || newWidth === loopWidth) return;
          loopWidth = newWidth;
          pxPerMs = loopWidth / (speedSeconds * 1000);
          wrapScroll();
        }

        function stopAutoScroll() {
          if (!autoScrollActive) return;
          autoScrollActive = false;
          if (autoScrollId) {
            cancelAnimationFrame(autoScrollId);
          }
          section.dataset.rollingAutoScrollStopped = "true";
        }

        function step(ts) {
          if (!autoScrollActive || autoScrollPaused) {
            autoScrollId = requestAnimationFrame(step);
            return;
          }
          if (lastTime == null) {
            lastTime = ts;
          }
          var delta = ts - lastTime;
          lastTime = ts;
          mask.scrollLeft += pxPerMs * delta;
          wrapScroll();
          autoScrollId = requestAnimationFrame(step);
        }

        if (stopOnInteract) {
          mask.addEventListener("pointerdown", stopAutoScroll, { passive: true });
          mask.addEventListener("touchstart", stopAutoScroll, { passive: true });
          mask.addEventListener("wheel", stopAutoScroll, { passive: true });
        }
        if (pauseOnHover) {
          mask.addEventListener("mouseenter", function () {
            autoScrollPaused = true;
          });
          mask.addEventListener("mouseleave", function () {
            autoScrollPaused = false;
            lastTime = null;
          });
        }

        autoScrollId = requestAnimationFrame(step);
        section.dataset.rollingAutoScrollInit = "true";

        if ("ResizeObserver" in window && section.dataset.rollingSwipeResizeInit !== "true") {
          var observer = new ResizeObserver(function () {
            updateLoopWidth();
          });
          observer.observe(mask);
          observer.observe(track);
          section.dataset.rollingSwipeResizeInit = "true";
        }
      }

      section.dataset.rollingSwipeInit = "true";
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRollingTestimonialsSwipe(document);
  });

  window.addEventListener("load", function () {
    initRollingTestimonialsSwipe(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initRollingTestimonialsSwipe(event.target || document);
  });
})();

(function () {
  function getAnimClass(style) {
    switch (style) {
      case "fade":
        return "anm-fade";
      case "fade-up":
        return "anm-fadeInUp";
      case "slide-left":
        return "anm-slideLeft";
      case "slide-right":
        return "anm-slideRight";
      case "zoom-out":
        return "anm-zoomOut";
      default:
        return "anm-fadeInUp";
    }
  }

  function initSwipeGroupAnimations(root) {
    if (!root) return;
    var sections = root.querySelectorAll('.swipe-group-section[data-swipe-animate="true"]');
    sections.forEach(function (section) {
      if (section.dataset.swipeAnimInit === "true") return;
      var disableMobile = section.dataset.animDisableMobile === "true";
      if (disableMobile && window.matchMedia("(max-width: 749px)").matches) {
        section.dataset.swipeAnimInit = "true";
        return;
      }

      var content = section.querySelector("[data-swipe-content]");
      if (!content) {
        section.dataset.swipeAnimInit = "true";
        return;
      }

      var animClass = getAnimClass(section.dataset.animStyle || "fade-up");
      var duration = parseFloat(section.dataset.animDuration || "0.6");
      var delay = parseFloat(section.dataset.animDelay || "0");
      var stagger = parseFloat(section.dataset.animStagger || "0.06");
      var offset = parseFloat(section.dataset.animOffset || "24");
      var children = Array.prototype.slice.call(content.children);

      children.forEach(function (child, index) {
        child.classList.add("anm", animClass);
        child.style.setProperty("--duration", duration + "s");
        child.style.setProperty("--delay", delay + stagger * index + "s");
        child.style.setProperty("--offset", offset + "px");
      });

      function activateStaggered() {
        children.forEach(function (child, index) {
          var ms = (delay + stagger * index) * 1000;
          setTimeout(function () {
            child.classList.add("animated");
          }, ms);
        });
        section.dataset.swipeAnimActivated = "true";
      }

      var target = section.querySelector(".swipe-group-section__inner") || content;
      if (!("IntersectionObserver" in window) || !target) {
        activateStaggered();
      } else {
        var observer = new IntersectionObserver(
          function (entries, obs) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                activateStaggered();
                obs.disconnect();
                return;
              }
            }
          },
          { threshold: 0.2 }
        );
        observer.observe(target);
      }

      section.dataset.swipeAnimInit = "true";
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initSwipeGroupAnimations(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initSwipeGroupAnimations(event.target || document);
  });
})();

(function () {
  function setInlineVideoState(video, isPlaying) {
    if (!video) {
      return;
    }
    var wrapper = video.closest('[data-video-inline-wrapper]');
    if (!wrapper) {
      return;
    }
    var hasPlayed = wrapper.dataset.inlinePlayed === 'true';
    wrapper.classList.toggle('is-playing', isPlaying || hasPlayed);
  }

  function enableInlineVideoControls(video) {
    if (!video) {
      return;
    }
    var wrapper = video.closest('[data-video-inline-wrapper]');
    if (!wrapper || wrapper.dataset.inlineControlsReady === 'true') {
      return;
    }
    video.controls = true;
    wrapper.dataset.inlineControlsReady = 'true';
  }

  document.addEventListener(
    'play',
    function (event) {
      if (event.target && event.target.tagName === 'VIDEO') {
        var wrapper = event.target.closest('[data-video-inline-wrapper]');
        if (wrapper) {
          wrapper.dataset.inlinePlayed = 'true';
        }
        setInlineVideoState(event.target, true);
        enableInlineVideoControls(event.target);
      }
    },
    true
  );

  document.addEventListener(
    'pause',
    function (event) {
      if (event.target && event.target.tagName === 'VIDEO') {
        setInlineVideoState(event.target, false);
      }
    },
    true
  );

  document.addEventListener(
    'ended',
    function (event) {
      if (event.target && event.target.tagName === 'VIDEO') {
        setInlineVideoState(event.target, false);
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    var playButton = event.target.closest('.js-video-inline-play');
    if (!playButton) {
      return;
    }
    var wrapper = playButton.closest('[data-video-inline-wrapper]');
    if (!wrapper) {
      return;
    }
    var video = wrapper.querySelector('video');
    if (!video) {
      return;
    }
    event.preventDefault();
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        setInlineVideoState(video, false);
      });
    }
  });
})();

// Debug PDP navigation + loader timing from pill tray clicks.
// Enable via ?debug-pdp-load=1 or localStorage.debugPdpLoad = "true".
(function () {
  var params = new URLSearchParams(window.location.search || '');
  var debugEnabled = params.get('debug-pdp-load') === '1' || localStorage.getItem('debugPdpLoad') === 'true';

  if (!debugEnabled) {
    return;
  }

  var navKey = 'pdpNavStart';
  var navHrefKey = 'pdpNavHref';
  var startStamp = sessionStorage.getItem(navKey);

  function log(label) {
    var now = Math.round(performance.now());
    var delta = startStamp ? Math.round(Date.now() - Number(startStamp)) : null;
    if (delta !== null && Number.isFinite(delta)) {
      console.log('[pdp-load]', label + ' @' + now + 'ms', 'delta-from-click=' + delta + 'ms');
    } else {
      console.log('[pdp-load]', label + ' @' + now + 'ms');
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.pill-tray__pill');
    if (!link) return;
    sessionStorage.setItem(navKey, String(Date.now()));
    sessionStorage.setItem(navHrefKey, link.href || '');
    console.log('[pdp-load] pill-tray click', link.href || '');
  });

  document.addEventListener('DOMContentLoaded', function () {
    log('DOMContentLoaded');
  });

  window.addEventListener('load', function () {
    log('window.load');
  });

  var body = document.body;
  if (body) {
    var loadingClassRe = /(loading|is-loading|page-loading|page--loading|transition)/i;
    var sawLoadingClass = loadingClassRe.test(body.className || '');
    var classObserver = new MutationObserver(function () {
      var hasLoading = loadingClassRe.test(body.className || '');
      if (sawLoadingClass && !hasLoading) {
        log('body-loading-removed');
        classObserver.disconnect();
      } else if (!sawLoadingClass && hasLoading) {
        sawLoadingClass = true;
      }
    });
    classObserver.observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  var loaderSelectors = [
    '.page-loader',
    '.loading-overlay',
    '.loading-screen',
    '.js-loading-overlay',
    '[data-page-loader]',
    '[data-loading-overlay]',
  ];
  var loaderState = {};

  function checkLoaders() {
    loaderSelectors.forEach(function (selector) {
      var node = document.querySelector(selector);
      if (!node) {
        if (loaderState[selector]) {
          log('loader-removed ' + selector);
          loaderState[selector] = null;
        }
        return;
      }
      if (!loaderState[selector]) {
        loaderState[selector] = node;
        log('loader-found ' + selector);
      }
      var isHidden = node.hidden || node.getAttribute('aria-hidden') === 'true';
      var style = window.getComputedStyle(node);
      var isDisplayNone = style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0');
      if (isHidden || isDisplayNone) {
        log('loader-hidden ' + selector);
        loaderState[selector] = null;
      }
    });
  }

  var domObserver = new MutationObserver(checkLoaders);
  domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
  });
  checkLoaders();
})();
